const dataDishes = [
    {
        id: 1,
        img: "crepes",
        name: "Crepes",
        category: "SWEET BREAKFAST",
        price: 3 
    },
    {
        id: 2,
        img: "waffles",
        name: "Waffles",
        category: "SWEET BREAKFAST",
        price: 4
    },
    {
        id: 3,
        img: "cheescake",
        name: "Cheescake",
        category: "CAKES",
        price: 9
    },
    {
        id: 4,
        img: "cinnamons",
        name: "Cinnamons rolls",
        category: "PASTRIES",
        price: 4
    },
    {
        id: 5,
        img: "pancakes",
        name: "Pancakes",
        category: "SWEET BREAKFAST",
        price: 5
    },
    {
        id: 6,
        img: "croissants",
        name: "Croissants",
        category: "PASTRIES",
        price: 4
    },
    {
        id: 7,
        img: "cookies_jam",
        name: "Cookies with jam",
        category: "COOKIES",
        price: 5
    },
    {
        id: 8,
        img: "oatmeal_chocolate_cookies",
        name: "Oatmeal chocolate cookies",
        category: "COOKIES",
        price: 6
    },
    {
        id: 9,
        img: "chocolate_cake",
        name: "Chocolate cake",
        category: "CAKES",
        price: 9
    },
    {
        id: 10,
        img: "donuts",
        name: "Donuts",
        category: "PASTRIES",
        price: 4
    },
    {
        id: 11,
        img: "honey_cake",
        name: "Honey cake",
        category: "CAKES",
        price: 8
    },
    {
        id: 12,
        img: "macarons",
        name: "Macarons",
        category: "COOKIES",
        price: 7
    },

]

export default dataDishes;